import { getAPIHeaderOptions, getDefaultParams, transformErrorResponse } from "../../utils/apiUtils";
import {
	ICreateSocietyRequestData,
	IEditSocietyRequestData,
	IGetAllCustomersResponseDetails,
	IGetCameraFramesListRequestData,
	IGetCameraFramesResponse,
	IGetSocietyConfigResponseData,
	IGetVehiclesListRequestData,
	IGetVehiclesListResponse,
	ISocietyConfigDetails,
	ISocietyImageLimitsResponseData,
	IUpdateSocietyImageLimitsRequestData,
	IUpdateVehicleRequestData
} from "../../types";
import { queriesApi } from "./queries.reducer";

export const settings = queriesApi.injectEndpoints({
	endpoints: (builder) => ({
		// GET SOCIETY CONFIG
		getSocietyConfig: builder.query<IGetSocietyConfigResponseData, number>({
			query: (societyId) => ({
				url: "/analytics/admin/society",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: { society: societyId }
			})
		}),

		// EDIT SOCIETY CONFIG
		editSocietyConfig: builder.mutation<ISocietyConfigDetails, IEditSocietyRequestData>({
			query: (requestData) => ({
				url: `/analytics/admin/society/${requestData.id}`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: { ...getDefaultParams(), ...requestData.data }
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// CREATE SOCIETY
		createSociety: builder.mutation<ISocietyConfigDetails, ICreateSocietyRequestData>({
			query: (requestData) => ({
				url: "/analytics/admin/society",
				headers: getAPIHeaderOptions(true),
				method: "POST",
				body: { ...getDefaultParams(), ...requestData }
			}),
			transformErrorResponse: transformErrorResponse
		}),

		// GET ALL CUSTOMERS
		getAllCustomers: builder.query<IGetAllCustomersResponseDetails[], void>({
			query: () => ({
				url: "/analytics/admin/list-societies",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: getDefaultParams()
			})
		}),

		// GET VEHICLES LIST
		getVehiclesList: builder.query<IGetVehiclesListResponse, IGetVehiclesListRequestData>({
			query: (requestData) => ({
				url: "/analytics/vehicle",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// UPDATE VEHICLE
		updateVehicle: builder.mutation<unknown, IUpdateVehicleRequestData>({
			query: (requestData) => ({
				url: `/analytics/vehicle/${requestData.id}`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: requestData.data
			})
		}),

		// GET CAMERA FRAMES LIST
		getCameraFramesList: builder.query<IGetCameraFramesResponse[], IGetCameraFramesListRequestData>({
			query: (requestData) => ({
				url: "/devices/camera_frames",
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: requestData
			})
		}),

		// GET SOCIETY IMAGE LIMITS
		getSocietyImageLimits: builder.query<ISocietyImageLimitsResponseData, number>({
			query: (societyId) => ({
				url: `/analytics/admin/society-image-limits/${societyId}`,
				headers: getAPIHeaderOptions(true),
				method: "GET",
				params: { ...getDefaultParams() }
			})
		}),

		// UPDATE SOCIETY IMAGE LIMITS
		updateSocietyImageLimits: builder.mutation<ISocietyImageLimitsResponseData, IUpdateSocietyImageLimitsRequestData>({
			query: (requestData) => ({
				url: `/analytics/admin/society-image-limits/${requestData.society_id}`,
				headers: getAPIHeaderOptions(true),
				method: "PATCH",
				body: { ...getDefaultParams(), ...requestData.data }
			}),
			transformErrorResponse: transformErrorResponse
		})
	})
});

export const {
	// GET SOCIETY CONFIG
	useGetSocietyConfigQuery,
	// EDIT SOCIETY CONFIG
	useEditSocietyConfigMutation,
	// CREATE SOCIETY
	useCreateSocietyMutation,
	// GET ALL CUSTOMERS
	useGetAllCustomersQuery,
	// GET VEHICLES LIST
	useGetVehiclesListQuery,
	// UPDATE VEHICLE
	useUpdateVehicleMutation,
	// GET CAMERA FRAMES LIST
	useGetCameraFramesListQuery,
	// GET SOCIETY IMAGE LIMITS
	useGetSocietyImageLimitsQuery,
	// UPDATE SOCIETY IMAGE LIMITS
	useUpdateSocietyImageLimitsMutation
} = settings;
